// extracted by mini-css-extract-plugin
export default {"wrapper":"ProjectWrapper_wrapper__5KsC-","title":"ProjectWrapper_title__WQNkL"};